type PlantPathSource = {
  common_name: string;
  scientific_name: string;
};

export function slugifyPlantName(value: string): string {
  return value
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80) || 'plant';
}

export function careGuidePath(plant: PlantPathSource): string {
  return `/plants/${slugifyPlantName(plant.scientific_name || plant.common_name)}`;
}

export function propagationGuidePath(plant: PlantPathSource): string {
  return `/propagation/${slugifyPlantName(plant.scientific_name || plant.common_name)}`;
}
